import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TipoUniversoService } from "../../../../../services/tipo-universo.service";
import { AuthService } from "../../../../../services/auth.service";
import { MatrizRiscoControleService } from "../../service/matriz-risco-controle.service";
import {
	IMatrizRiscoControle,
	IMatrizRiscoControleRisco, IMatrizRiscoEscalaMagnitude
} from "../../model/matriz-risco-controle.model";
import Swal from "sweetalert2";
import { UnidadeGestoraService } from "../../../../../services/unidade-gestora.service";
import { IMaginitudesEscalaRisco } from "../../../../../models/maginitudes-escala-risco.model";
import { EscalasService } from "../../../../../services/escalas.service";
import { IEscalas } from "../../../../../models/escalas.model";
import { MagnitudesEscalaRiscoService } from "../../../../../services/magnitudes-escala-risco.service";
import * as XLSX from 'xlsx';
@Component({
	selector: "app-imprimir-matriz-risco",
	templateUrl: "imprimir-matriz-risco.component.html",
	styleUrls: ["imprimir-matriz-risco.component.scss"],
})
export class ImprimirMatrizRiscoComponent implements OnInit {
	id: number;
	idPlanejamento: number;
	idUnidade: number;
	nomeUnidadeGestora: string;
	@Input() dados: IMatrizRiscoControle = {} as IMatrizRiscoControle;
	listEscalas: IMatrizRiscoEscalaMagnitude[] = [];
	// @Input() dadosExport!: IMatrizRiscoControle;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private matrizControleService: MatrizRiscoControleService,
		private unidadeGestoraService: UnidadeGestoraService,
		private magnitutesService: MagnitudesEscalaRiscoService,
		private escalaService: EscalasService,
		public authService: AuthService
	) {
		this.id = Number(this.route.snapshot.paramMap.get("id"));
		this.idPlanejamento = Number(
			this.route.snapshot.paramMap.get("idPlanejamento")
		);
		this.idUnidade = Number(this.route.snapshot.paramMap.get("idUnidade"));
	}

	async ngOnInit() {
		await this.matrizControleService
			.obterPorPlanejamento(this.idPlanejamento, this.idUnidade, this.id)
			.then((res) => {
				if (res.dados) {
					this.dados = res.dados[0] as IMatrizRiscoControle;
					this.dados.testes?.forEach(teste => {
						teste.questoes = (teste.questoes ?? []).sort(
							(a, b) => (a.ordem ?? 0) - (b.ordem ?? 0)
						);
					});
					this.carregaEscalas(this.dados.idCriterioAvaliacao);
				}
			})
			.catch((err) => {
				Swal.fire({
					toast: true,
					position: "top-end",
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
					icon: "error",
					title: "Erro",
					text: err?.mensagem?.descricao || "Erro ao carregar dados",
				});
			});

		if (this.idUnidade !== 0) {
			await this.unidadeGestoraService
				.obterPorId(this.idUnidade)
				.then((res) => {
					if (res.sucesso) {
						this.nomeUnidadeGestora =
							res.dados.sigla + " " + res.dados.nome;
					}
				});
		}

		// this.debugEstrutura();
	}

	public async carregarDados(id: number, idPlanejamento: number, idUnidade: number) {
		this.id = id;
		this.idPlanejamento = idPlanejamento;
		this.idUnidade = idUnidade;

		await this.matrizControleService
			.obterPorPlanejamento(this.idPlanejamento, this.idUnidade, this.id)
			.then((res) => {
				if (res.dados) {
					console.log(res.dados);
					this.dados = res.dados[0] as IMatrizRiscoControle;
					this.carregaEscalas(this.dados.idCriterioAvaliacao);
				}
			})
			.catch((err) => {
				Swal.fire({
					toast: true,
					position: "top-end",
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
					icon: "error",
					title: "Erro",
					text: err?.mensagem?.descricao || "Erro ao carregar dados",
				});
			});

		await this.unidadeGestoraService
			.obterPorId(this.idUnidade)
			.then((res) => {
				if (res.sucesso) {
					this.nomeUnidadeGestora = res.dados.sigla + " " + res.dados.nome;
				}
			});
	}

	setListEscalas(dados: IEscalas[]) {
		this.listEscalas = [];
		for (let i = 0; i < dados.length; i++) {
			const element = dados[i];
			const novo: IMatrizRiscoEscalaMagnitude = {} as IMatrizRiscoEscalaMagnitude;
			novo.id = element.id;
			novo.listMagnitude = [];
			novo.idMagnitudeSelecionado = '0';
			novo.nome = element.nome;
			this.listEscalas.push(novo);
		}
	}

	carregaEscalas(idCriterioAvaliacao: any) {
		this.escalaService.obter(idCriterioAvaliacao.toString(), true, true).then((res) => {
			this.setListEscalas(res?.dados);
			for (let i = 0; i < this.listEscalas.length; i++) {
				// this.listDadosFormula.push({ campo: '', operador: '' })

				const element = this.listEscalas[i];
				this.magnitutesService.obter(element.id as any, true, true).then((res) => {
					element.listMagnitude = [...res?.dados as IMaginitudesEscalaRisco[]];
				});
			}
		});
	}
	getMagnitudeValue(risco: any, escala: any): string {
		if (!risco?.calculos || !escala?.listMagnitude) {
			return '—';
		}

		const calculo = risco.calculos.find((c: any) => c.idEscala === escala.id);
		if (!calculo) {
			return '—';
		}

		const magnitude = escala.listMagnitude.find((m: any) => m.id === calculo.idMagnitude);
		if (!magnitude) {
			return '—';
		}
		return `${magnitude.valor} - (${magnitude.magnitude})`;
	}

	public cancelar() {
		window.history.back();
	}

	formatarRef(ref: number | string): string {
		const numero = Number(ref);
		if (!isNaN(numero) && numero >= 1 && numero <= 9) {
			return "0" + numero;
		}
		return ref?.toString() || "-";
	}

	exportar() {
		// Cria os dados manualmente seguindo a estrutura do template
		const dados = this.prepararDadosParaExcel();

		const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(dados);

		// Aplica estilos e formatações
		this.aplicarEstilosExcel(ws);

		// Define largura das colunas
		this.definirLarguraColunas(ws);

		// Mescla células do cabeçalho
		this.mesclarCelulsCabecalho(ws);

		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Matriz de Risco');

		// Salva o arquivo
		XLSX.writeFile(wb, `matriz-risco-${this.dados.nomeProcesso || 'export'}.xlsx`);
	}
	private prepararDadosParaExcel(): any[][] {
		const dados: any[][] = [];

		dados.push(['Mapeamento de Processo, Riscos e Controles Associados']);

		dados.push([]);

		dados.push([`Unidade auditada: ${this.nomeUnidadeGestora || ''}`]);
		dados.push([`Processo de Trabalho Auditado: ${this.dados.nomeProcesso || ''}`]);

		dados.push([]);

		const primeiraLinha = [];


		primeiraLinha.push('ATIVIDADE', '', '', '');

		// RISCOS (3 colunas base + escalas + 1 nível RI)
		const numColunasRiscos = 3 + this.listEscalas.length + 1; // Descrição, Causa, Consequência + escalas + Nível RI
		primeiraLinha.push('RISCOS');
		for (let i = 1; i < numColunasRiscos; i++) {
			primeiraLinha.push('');
		}

		primeiraLinha.push('CONTROLES', '', '', '', '');

		primeiraLinha.push('TESTES', '', '');

		dados.push(primeiraLinha);

		const segundaLinha = [
			// ATIVIDADE (4 colunas)
			'Ref',
			'Descrição da Atividade (O quê?)',
			'Responsável (Quem?)',
			'Como',
			// RISCOS (6 colunas base + escalas + nível)
			'Descrição',
			'Causa Risco',
			'Consequência',
			...this.listEscalas.map(escala => escala.nome), // colunas dinâmicas
			'Nível de Risco Inerente (RI)',
			// CONTROLES (5 colunas)
			'Descrição do Controle Verificado',
			'Avaliação',
			'Risco de Controle (RC)',
			'Risco Residual (RR = RI x RC)',
			'Melhor Prática',
			// TESTES (3 colunas)
			'Prioridade',
			'Tipo de Teste',
			'Questão / Subquestão'
		];
		dados.push(segundaLinha);

		if (this.dados.atividades) {
			this.dados.atividades.forEach(atividade => {
				const riscos = this.getRiscosPorAtividade(atividade.id);

				if (riscos.length > 0) {
					riscos.forEach(risco => {
						const associados = this.getAssociadosPorRisco(risco.id);

						if (associados.length > 0) {
							associados.forEach(associado => {
								const testes = this.getTestesPorAssociado(associado.id);

								if (testes.length > 0) {
									testes.forEach(teste => {
										const linha = this.criarLinhaCompleta(atividade, risco, associado, teste);
										dados.push(linha);
									});
								} else {
									// Associado sem testes
									const linha = this.criarLinhaCompleta(atividade, risco, associado, null);
									dados.push(linha);
								}
							});
						} else {
							// Risco sem associados
							const linha = this.criarLinhaCompleta(atividade, risco, null, null);
							dados.push(linha);
						}
					});
				} else {
					// Atividade sem riscos
					const linha = this.criarLinhaCompleta(atividade, null, null, null);
					dados.push(linha);
				}
			});
		}

		return dados;
	}

	private criarLinhaCompleta(atividade: any, risco: any, associado: any, teste: any): any[] {
		const linha = [];

		linha.push(`AT${this.formatarRef(atividade.posicao)}`);
		linha.push(atividade.descricao || '');
		linha.push(atividade.responsavel || '');
		linha.push(atividade.comoRealizada || '');

		// RISCOS
		if (risco) {
			linha.push(risco.descricaoRisco || '');


			const causas = risco.causas?.map((causa: any) => causa.descricao).join('; ') || '';
			linha.push(causas);

			const consequencias = risco.consequencias?.map((cons: any) => cons.descricao).join('; ') || '';
			linha.push(consequencias);

			this.listEscalas.forEach(escala => {
				linha.push(this.getMagnitudeValue(risco, escala));
			});

			// Nível de Risco Inerente
			linha.push(`${risco.resultadoRI || ''} (${risco.nivelRI || ''})`);
		} else {
			// Preenche com células vazias se não houver risco
			linha.push('', '', ''); // Descrição, Causa, Consequência
			this.listEscalas.forEach(() => linha.push('')); // Escalas
			linha.push(''); // Nível RI
		}

		// CONTROLES
		if (associado) {
			linha.push(associado.descricao || '—');
			linha.push(associado.descricaoControle || '—');
			linha.push(associado.valorRI || '—');
			linha.push(
				`${associado.valorCalculado ?? '—'} (${associado.nivelRR ?? '—'})`
			);
			linha.push(associado.descricaoMelhorPratica || '—');
		} else {
			linha.push('—', '—', '—', '—', '—');
		}

		// TESTES
		if (teste) {
			linha.push(teste.prioridade || '');
			linha.push(teste.tipoTeste || '');

			// ← ajustado: aplica a mesma regra de "Não realizará testes"
			if (teste.realizarTestes === false) {
				linha.push(`Não serão realizados testes/Não incluído no escopo da auditoria. ${teste.justificativa || ''}`);
			} else {
				const questoes = teste.questoes?.map((q: any) => q.nomeQuestao || '—').join('; ') || '';
				linha.push(questoes);
			}
		} else {
			linha.push('', '', '');
		}

		return linha;
	}

	private aplicarEstilosExcel(ws: XLSX.WorkSheet) {
		const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');

		const tituloCell = XLSX.utils.encode_cell({ r: 0, c: 0 });
		if (ws[tituloCell]) {
			ws[tituloCell].s = {
				font: {
					bold: true,
					size: 18,
					color: { rgb: '2C3E50' }, // Cor mais escura e profissional
					name: 'Calibri'
				},
				alignment: { horizontal: 'center', vertical: 'center' },
				fill: { fgColor: { rgb: 'E8F4FD' } }, // Fundo azul claro
				border: this.getBorderStyleThick()
			};
		}


		for (let row = 2; row <= 3; row++) {
			const cellAddress = XLSX.utils.encode_cell({ r: row, c: 0 });
			if (ws[cellAddress]) {
				ws[cellAddress].s = {
					font: {
						bold: true,
						size: 14,
						color: { rgb: '34495E' },
						name: 'Calibri'
					},
					alignment: { horizontal: 'left', vertical: 'center' },
					fill: { fgColor: { rgb: 'F8F9FA' } }, // Fundo cinza claro
					border: this.getBorderStyle()
				};
			}
		}


		const linhaCabecalho1 = 5; // Primeira linha do cabeçalho (agrupamentos)
		const linhaCabecalho2 = 6; // Segunda linha do cabeçalho (títulos específicos)


		for (let col = range.s.c; col <= range.e.c; col++) {
			const cellAddress = XLSX.utils.encode_cell({ r: linhaCabecalho1, c: col });
			if (ws[cellAddress]) {
				ws[cellAddress].s = {
					font: {
						bold: true,
						color: { rgb: 'FFFFFF' },
						size: 12,
						name: 'Calibri'
					},
					alignment: { horizontal: 'center', vertical: 'center' },
					border: this.getBorderStyleThick(),
					fill: this.getFillColorBySection(col)
				};
			}
		}


		for (let col = range.s.c; col <= range.e.c; col++) {
			const cellAddress = XLSX.utils.encode_cell({ r: linhaCabecalho2, c: col });
			if (ws[cellAddress]) {
				ws[cellAddress].s = {
					font: {
						bold: true,
						color: { rgb: 'FFFFFF' },
						size: 11,
						name: 'Calibri'
					},
					alignment: { horizontal: 'center', vertical: 'center' },
					border: this.getBorderStyle(),
					fill: { fgColor: { rgb: '495057' } } // Cinza escuro mais suave
				};
			}
		}


		for (let row = 7; row <= range.e.r; row++) {
			for (let col = range.s.c; col <= range.e.c; col++) {
				const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
				if (ws[cellAddress]) {
					ws[cellAddress].s = {
						font: {
							size: 10,
							name: 'Calibri',
							color: { rgb: '212529' }
						},
						border: this.getBorderStyle(),
						alignment: {
							horizontal: col === 0 ? 'center' : 'left', // Ref centralizada
							vertical: 'top',
							wrapText: true
						},
						fill: this.getAlternatingRowColor(row)
					};
				}
			}
		}
	}

	private getFillColorBySection(colIndex: number): any {
		const atividadeEnd = 3; // colunas 0-3 (4 colunas)
		const numEscalas = this.listEscalas.length;
		const riscosEnd = 4 + 3 + numEscalas; // início(4) + base(3) + escalas - 1 para última coluna
		const controlesEnd = riscosEnd + 5; // próximas 5 colunas

		if (colIndex <= atividadeEnd) {
			return { fgColor: { rgb: 'FFC107' } }; // bg-warning (ATIVIDADE)
		} else if (colIndex <= riscosEnd) {
			return { fgColor: { rgb: 'F0AD4E' } }; // bg-orange (RISCOS)
		} else if (colIndex <= controlesEnd) {
			return { fgColor: { rgb: '5BC0DE' } }; // bg-info (CONTROLES)
		} else {
			return { fgColor: { rgb: '5CB85C' } }; // bg-success (TESTES)
		}
	}
	private getBorderStyle(): any {
		return {
			top: { style: 'thin', color: { rgb: '6C757D' } },
			bottom: { style: 'thin', color: { rgb: '6C757D' } },
			left: { style: 'thin', color: { rgb: '6C757D' } },
			right: { style: 'thin', color: { rgb: '6C757D' } }
		};
	}

	private getBorderStyleThick(): any {
		return {
			top: { style: 'medium', color: { rgb: '495057' } },
			bottom: { style: 'medium', color: { rgb: '495057' } },
			left: { style: 'medium', color: { rgb: '495057' } },
			right: { style: 'medium', color: { rgb: '495057' } }
		};
	}

	private getAlternatingRowColor(row: number): any {

		const isEvenRow = (row - 7) % 2 === 0;
		return isEvenRow
			? { fgColor: { rgb: 'FFFFFF' } }
			: { fgColor: { rgb: 'F8F9FA' } };
	}

	private mesclarCelulsCabecalho(ws: XLSX.WorkSheet) {
		// Mescla a célula do título principal na primeira linha
		const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');
		ws['!merges'] = ws['!merges'] || [];
		ws['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: range.e.c } });

		// Mescla células da primeira linha do cabeçalho (agora linha 5)
		const numEscalas = this.listEscalas.length;
		const linhaCabecalho = 5;

		// ATIVIDADE (colunas 0-3) - 4 colunas
		ws['!merges'].push({ s: { r: linhaCabecalho, c: 0 }, e: { r: linhaCabecalho, c: 3 } });

		// RISCOS - calcula posição corretamente
		const inicioRiscos = 4;
		const numColunasRiscos = 3 + numEscalas + 1; // Descrição, Causa, Consequência + escalas + Nível RI
		const fimRiscos = inicioRiscos + numColunasRiscos - 1;
		ws['!merges'].push({ s: { r: linhaCabecalho, c: inicioRiscos }, e: { r: linhaCabecalho, c: fimRiscos } });

		// CONTROLES (próximas 5 colunas)
		const inicioControles = fimRiscos + 1;
		const fimControles = inicioControles + 4; // 5 colunas (0-4)
		ws['!merges'].push({ s: { r: linhaCabecalho, c: inicioControles }, e: { r: linhaCabecalho, c: fimControles } });

		// TESTES (últimas 3 colunas)
		const inicioTestes = fimControles + 1;
		const fimTestes = inicioTestes + 2; // 3 colunas (0-2)
		ws['!merges'].push({ s: { r: linhaCabecalho, c: inicioTestes }, e: { r: linhaCabecalho, c: fimTestes } });
	}

	private definirLarguraColunas(ws: XLSX.WorkSheet) {
		const cols = [
			{ wch: 10 },  // Ref - um pouco mais larga
			{ wch: 40 },  // Descrição da Atividade - mais larga para textos longos
			{ wch: 25 },  // Responsável
			{ wch: 30 },  // Como - mais larga
			{ wch: 45 },  // Descrição do Risco - mais larga
			{ wch: 35 },  // Causa Risco - mais larga
			{ wch: 35 },  // Consequência - mais larga
		];

		// Adiciona largura para colunas de escalas
		this.listEscalas.forEach(() => {
			cols.push({ wch: 20 }); // Um pouco mais larga para escalas
		});

		cols.push(
			{ wch: 28 },  // Nível de Risco Inerente - mais larga
			{ wch: 45 },  // Descrição do Controle - mais larga
			{ wch: 25 },  // Avaliação
			{ wch: 20 },  // Risco de Controle
			{ wch: 25 },  // Risco Residual
			{ wch: 35 },  // Melhor Prática - mais larga
			{ wch: 18 },  // Prioridade
			{ wch: 25 },  // Tipo de Teste
			{ wch: 50 }   // Questão / Subquestão - muito mais larga
		);

		ws['!cols'] = cols;

		// Define altura das linhas
		ws['!rows'] = ws['!rows'] || [];

		// Altura maior para o título
		ws['!rows'][0] = { hpx: 30 };

		// Altura para as informações do processo
		ws['!rows'][2] = { hpx: 25 };
		ws['!rows'][3] = { hpx: 25 };

		// Altura para cabeçalhos
		ws['!rows'][5] = { hpx: 35 };
		ws['!rows'][6] = { hpx: 40 };

		// Altura padrão para linhas de dados
		const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');
		for (let row = 7; row <= range.e.r; row++) {
			ws['!rows'][row] = { hpx: 25 };
		}
	}


	getRiscosPorAtividade(idAtividade: number) {
		return this.dados.riscos.filter(risco => risco.idMatrizAtividades === idAtividade);
	}

	getAssociadosPorRisco(idRisco: number) {
		return this.dados.associados.filter(associado => associado.idMatrizRiscoControleRiscos === idRisco);
	}

	getTestesPorAssociado(idAssociado: number) {
		return this.dados.testes.filter(teste => teste.idMatrizRiscoControleAssociados === idAssociado);
	}


	getTotalLinhasPorAtividade(idAtividade: number): number {
		let totalLinhas = 0;

		const riscos = this.getRiscosPorAtividade(idAtividade);

		// Se a atividade não tem riscos, ela ocupará 1 linha
		if (riscos.length === 0) {
			return 1;
		}

		// Para cada risco da atividade
		for (const risco of riscos) {
			const associados = this.getAssociadosPorRisco(risco.id);

			// Se o risco não tem associados, ele ocupará 1 linha
			if (associados.length === 0) {
				totalLinhas += 1;
				continue;
			}

			// Para cada associado do risco
			for (const associado of associados) {
				const testes = this.getTestesPorAssociado(associado.id);

				// Se o associado não tem testes, ele ocupará 1 linha
				// Se tem testes, ocupará o número de testes
				totalLinhas += Math.max(1, testes.length);
			}
		}

		return totalLinhas;
	}

	getTotalLinhasPorRisco(idRisco: number): number {
		let totalLinhas = 0;

		const associados = this.getAssociadosPorRisco(idRisco);

		// Se o risco não tem associados, ele ocupará 1 linha
		if (associados.length === 0) {
			return 1;
		}

		// Para cada associado do risco
		for (const associado of associados) {
			const testes = this.getTestesPorAssociado(associado.id);

			// Se o associado não tem testes, ele ocupará 1 linha
			// Se tem testes, ocupará o número de testes
			totalLinhas += Math.max(1, testes.length);
		}

		return totalLinhas;
	}

	getTotalLinhasPorAssociado(idAssociado: number): number {
		const testes = this.getTestesPorAssociado(idAssociado);
		return Math.max(1, testes.length);
	}

	debugEstrutura() {
		console.log('=== DEBUG ESTRUTURA ===');

		this.dados.atividades.forEach(atividade => {
			const totalAtividade = this.getTotalLinhasPorAtividade(atividade.id);
			console.log(`Atividade ${atividade.id}: ${totalAtividade} linhas`);

			const riscos = this.getRiscosPorAtividade(atividade.id);
			riscos.forEach(risco => {
				const totalRisco = this.getTotalLinhasPorRisco(risco.id);
				console.log(`  Risco ${risco.id}: ${totalRisco} linhas`);

				const associados = this.getAssociadosPorRisco(risco.id);
				associados.forEach(associado => {
					const totalAssociado = this.getTotalLinhasPorAssociado(associado.id);
					const testes = this.getTestesPorAssociado(associado.id);
					console.log(`    Associado ${associado.id}: ${totalAssociado} linhas (${testes.length} testes)`);
				});
			});
		});
	}
	public imprimir(): void {
		const root = document.getElementById('print-root');
		if (!root) return;

		// pega também o topo do print-layout (caso tenha header/logo dentro do layout)
		const layout = root.closest('app-print-layout') as HTMLElement;

		// se o print-layout tiver um container interno (ex: .page-print),
		// imprime ele inteiro; senão imprime só o root.
		const htmlToPrint = (layout?.querySelector('.page-print') as HTMLElement)?.outerHTML
			|| (layout?.querySelector('.content-print') as HTMLElement)?.outerHTML
			|| root.outerHTML;

		const w = window.open('', '_blank', 'width=1400,height=900');
		if (!w) return;

		w.document.open();
		w.document.write(`
<!doctype html>
<html lang="pt-br">
<head>
  <meta charset="utf-8" />
  <title>Impressão - Matriz</title>

  <style>
    /* ✅ FORÇA O FORMATO */
    @page { size: A3 landscape; margin: 8mm; }

    html, body { margin: 0; padding: 0; }
    body {
      font-family: Arial, sans-serif;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    /* ✅ garante largura total (remove max-width do layout) */
    .page-print, .content-print, .conteudo-impressao {
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      overflow: visible !important;
    }

    /* ✅ não pode ter scroll no print */
    .table-responsive {
      overflow: visible !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    /* ✅ TABELA */
    table.table {
      width: 100% !important;
      min-width: 0 !important;
      border-collapse: collapse !important;
      table-layout: fixed !important;
    }

    table.table th.col-questao,
    table.table td.col-questao {
      width: 12% !important;
    }

    table.table th,
    table.table td {
      border: 1px solid #000 !important;
      padding: 2px 2px !important;
      font-size: 8px !important;
      line-height: 1.15 !important;

      width: auto !important;
      min-width: 0 !important;
      max-width: none !important;

      white-space: normal !important;
      word-break: break-word !important;
      overflow-wrap: anywhere !important;
      vertical-align: top !important;
    }

    /* ✅ evita que o navegador “encaixe” cortando */
    tr, td, th { break-inside: avoid; page-break-inside: avoid; }

    /* ====== CORES (Bootstrap-like) ====== */
    .bg-dark { background: #212529 !important; color: #fff !important; }
    .text-white { color: #fff !important; }
    .bg-warning { background: #ffc107 !important; color: #000 !important; }
    .bg-info { background: #0dcaf0 !important; color: #000 !important; }
    .bg-success { background: #198754 !important; color: #fff !important; }
    .bg-orange { background: #f0ad4e !important; color: #000 !important; }
    .text-center { text-align: center !important; }

    /* lista de questões */
    ul { margin: 0; padding-left: 1rem; }

    /* itens de causa/consequência */
    .item-lista-risco {
      border-bottom: 1px solid #ccc;
      padding-bottom: 2px;
      margin-bottom: 2px;
      text-align: center;
      display: block;
      width: 100%;
    }
    .item-lista-risco:last-child { border-bottom: none; margin-bottom: 0; }

    /* se ainda ficar apertado, ative scale */
    /* .conteudo-impressao { transform: scale(0.9); transform-origin: top left; width: 111%; } */
  </style>
</head>

<body>
  ${htmlToPrint}
  <script>
    window.onload = function () {
      window.focus();
      window.print();
      window.close();
    }
  </script>
</body>
</html>
  `);
		w.document.close();
	}

}
